import loadingGif from "@/assets/loading.gif";

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const LoadingSpinner = ({ size = 'md', className = '' }: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-16 w-16',
    lg: 'h-32 w-32'
  };

  return (
    <img 
      src={loadingGif} 
      alt="Loading" 
      className={`object-contain ${sizeClasses[size]} ${className}`}
    />
  );
};
